export const SITE = {
  brand: "POSH Compliance",
  tagline: "POSH Compliance · Corporate Training · Legal Advisory",
  phone: "9027795197",
  phoneHref: "tel:+919027795197",
  email: "csrishisohar@gmail.com",
  emailHref: "mailto:csrishisohar@gmail.com",
  whatsapp: "https://wa.me/919027795197",
  whatsappMessage: "Hi, I'm interested in POSH compliance & training services.",
};

export const WHATSAPP_LINK = `${SITE.whatsapp}?text=${encodeURIComponent(
  SITE.whatsappMessage,
)}`;

export const SERVICES = [
  {
    icon: "bi-people-fill",
    title: "POSH Training Programs",
    desc: "Interactive, scenario-based training sessions for employees, managers and leadership — tailored to your industry.",
  },
  {
    icon: "bi-shield-check",
    title: "IC Formation & Training",
    desc: "End-to-end setup and capacity building of your Internal Committee, aligned with the POSH Act, 2013.",
  },
  {
    icon: "bi-file-earmark-text",
    title: "POSH Policy Drafting",
    desc: "Customized, legally-compliant POSH policies drafted and reviewed by certified Company Secretaries.",
  },
  {
    icon: "bi-calendar-check",
    title: "Annual Compliance & Filings",
    desc: "Annual report preparation, filings and ongoing compliance calendar — zero-stress for your HR team.",
  },
  {
    icon: "bi-journal-bookmark",
    title: "Legal & Governance Advisory",
    desc: "Companies Act, M&A, due diligence, agreement vetting, ROC / MCA liaisoning and governance consulting.",
  },
  {
    icon: "bi-mortarboard",
    title: "Awareness Programs",
    desc: "'Good Touch - Bad Touch', POSH awareness and NGO programs to build respectful, inclusive cultures.",
  },
];

export const EXPERTS = [
  {
    name: "CS Rishi Sohar",
    role: "Founder · Certified POSH Trainer",
    image:
      "/images/2.jpg",
    bio: "Certified POSH Trainer and corporate legal expert with 8+ years of experience in compliance, governance, and advisory. Expert in Companies Act, mergers & acquisitions, and corporate structuring. Associated with Pink & Blue Symbiotic Living and serves as an Independent Director.",
    tags: ["Companies Act", "M&A", "Independent Director", "POSH"],
  },
  {
    name: "CS Kanchan Aggarwal",
    role: "Company Secretary · POSH Professional",
    image:
      "/images/1.jpg",
    bio: "Certified POSH professional and Compliance Officer with 7+ years of experience in corporate governance, legal compliance, and advisory. Expert in POSH compliance, IC training, and workplace awareness programs. Actively associated with NGOs and social safety initiatives.",
    tags: ["LL.B", "CS", "POSH", "IC Advisory", "NGO"],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Their POSH training transformed how our leadership and teams think about workplace safety. Practical, engaging and legally robust — exactly what we needed.",
    name: "Priya Malhotra",
    role: "HR Head, IT Services Firm",
    initials: "PM",
    rating: 5,
  },
  {
    quote:
      "CS Rishi and his team handled our IC formation and policy drafting end-to-end. Clear communication, deep legal expertise and zero compliance gaps.",
    name: "Rajesh Khanna",
    role: "Director, Manufacturing Co.",
    initials: "RK",
    rating: 4,
  },
  {
    quote:
      "CS Kanchan's awareness sessions for our NGO — including 'Good Touch, Bad Touch' — were delivered with such empathy and clarity. Highly recommended.",
    name: "Aarti Sharma",
    role: "Founder, Community NGO",
    initials: "AS",
    rating: 4.5,
  },
  {
    quote:
      "From annual filings to governance advisory, POSH Compliance has been a reliable partner. Professional, proactive and always available.",
    name: "Vikram Desai",
    role: "CFO, Fintech Startup",
    initials: "VD",
    rating: 5,
  },
];

export const WHY_US = [
  {
    icon: "bi-balance-scale",
    title: "Legal + Practical Approach",
    desc: "We blend statutory precision with on-the-ground workplace realities, so policies actually work.",
  },
  {
    icon: "bi-buildings",
    title: "Corporate & NGO Experience",
    desc: "From MNCs and startups to NGOs and community programs — we've served a wide spectrum of organizations.",
  },
  {
    icon: "bi-shield-lock",
    title: "End-to-End Compliance",
    desc: "Policy, committee, training, annual filings — a single accountable partner for your entire POSH lifecycle.",
  },
  {
    icon: "bi-chat-quote",
    title: "Strong Training Delivery",
    desc: "Scenario-based, interactive sessions that drive real behavior change — not just tick-box training.",
  },
];
